//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// local
import * as s from "./ChromeNav.styles";
// other imports
import { ChromeFeedback } from "@components/chrome-feedback";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { openTeam } from "@actions/settings.actions";
import { PostMessageManager } from "@util/post-message.util";
// util
import { ChromeAppWrapperView } from "@util/chrome-extension.util";
// material-ui
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { MoreVert, ArrowDropDownCircle, Settings, Edit } from "@material-ui/icons";

//////////////////
// TYPES
//////////////////
export interface IContainer {
  editTeam?: boolean;
  feedback?: boolean;
  settings?: boolean;
}

interface IProps extends IContainer, WithStyles<typeof s.styles> {
  setSettingsDialogOpen: typeof setSettingsDialogOpen;
  openTeam: typeof openTeam;
  activeView: ChromeAppWrapperView;
  externalEventId: string;
  calendarId: string;
}

interface IState {
  anchorEl: HTMLElement | null;
}

//////////////////
// COMPONENT
//////////////////
class ChromeNavMenuCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  private openSettings = (goToTeam = false) => {
    this.props.setSettingsDialogOpen(true);
    if (goToTeam) {
      this.props.openTeam();
    }
    this.onCloseMenu();
  };

  private hideExtension = () => {
    PostMessageManager.closeSidebar(true);
    this.onCloseMenu();
  };

  private toggleOpen = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };

  private gotoEditEvent = () => {
    const { calendarId, externalEventId } = this.props;
    PostMessageManager.goToEventEditPage(externalEventId, calendarId);
    this.onCloseMenu();
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderButton = () => (
    <Tooltip title="Options">
      <IconButton onClick={this.toggleOpen} cw-id="chrome-nav-menu-options-button">
        <MoreVert className={this.props.classes.menuIcon} />
      </IconButton>
    </Tooltip>
  );

  public render() {
    const { editTeam, activeView, feedback, settings } = this.props;

    const isEventActiveView = activeView === ChromeAppWrapperView.Event;

    return (
      <React.Fragment>
        {this.renderButton()}
        <Menu
          open={!!this.state.anchorEl}
          anchorEl={this.state.anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={this.onCloseMenu}
          onBackdropClick={this.onCloseMenu}
          onEscapeKeyDown={this.onCloseMenu}
        >
          {isEventActiveView ? (
            <MenuItem onClick={this.gotoEditEvent}>
              <ListItemIcon>
                <Edit htmlColor={greys.slate} />
              </ListItemIcon>
              <ListItemText inset primary="Edit event" />
            </MenuItem>
          ) : (
            ""
          )}
          {isEventActiveView && <Divider style={s.divider} />}
          {!!editTeam ? (
            <MenuItem onClick={() => this.openSettings(true)}>
              <ListItemIcon>
                <Edit htmlColor={greys.slate} />
              </ListItemIcon>
              <ListItemText inset primary="Edit team" />
            </MenuItem>
          ) : (
            ""
          )}
          {!!editTeam && <Divider style={s.divider} />}
          {!!settings ? (
            <MenuItem onClick={() => this.openSettings()} cw-id="chrome-nav-menu-settings-button">
              <ListItemIcon>
                <Settings htmlColor={greys.slate} />
              </ListItemIcon>
              <ListItemText inset primary="Settings" />
            </MenuItem>
          ) : (
            ""
          )}
          {!!feedback && <Divider style={s.divider} />}
          {!!feedback && <ChromeFeedback />}
          <Divider style={s.divider} />
          <MenuItem
            onClick={() => this.hideExtension()}
            cw-id="chrome-nav-menu-hide-clockwise-button"
          >
            <ListItemIcon>
              <div style={{ transform: "rotate(-90deg)" }}>
                <ArrowDropDownCircle htmlColor={greys.slate} />
              </div>
            </ListItemIcon>
            <ListItemText inset primary="Hide Clockwise" />
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}

/////////////////
// WITH STYLES
/////////////////
const ChromeNavMenuStyled = withStyles(s.styles)(ChromeNavMenuCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    activeView: state.webExtension.activeView,
    externalEventId: state.webExtension.activeViewEvent.externalEventId,
    calendarId: state.webExtension.activeViewEvent.calendarId,
  };
}

export const ChromeNavMenu = connect(mapStateToProps, {
  setSettingsDialogOpen,
  openTeam,
})(ChromeNavMenuStyled);
